import { render, staticRenderFns } from "./SimpleMap.vue?vue&type=template&id=4dd047f4&scoped=true"
import script from "./SimpleMap.vue?vue&type=script&lang=ts"
export * from "./SimpleMap.vue?vue&type=script&lang=ts"
import style0 from "./SimpleMap.vue?vue&type=style&index=0&id=4dd047f4&prod&scoped=true&lang=scss"
import style1 from "./SimpleMap.vue?vue&type=style&index=1&id=4dd047f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd047f4",
  null
  
)

export default component.exports